"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvVariable = exports.isNonProd = exports.isLocal = exports.isTest = exports.isProd = exports.getEnvironment = void 0;
const Environment_1 = require("../types/environment/Environment");
const envVariables_1 = __importDefault(require("../constants/envVariables"));
const getEnvironment = () => {
    const hostname = window.location.hostname;
    if (hostname.indexOf('localhost') > -1 || hostname.indexOf('10.0.2.2') > -1) {
        return Environment_1.Environment.LOCAL;
    }
    if (hostname.indexOf('-np') > -1 ||
        hostname.indexOf('np-') > -1 ||
        hostname.indexOf('-np-') > -1) {
        return Environment_1.Environment.TEST;
    }
    return Environment_1.Environment.PROD;
};
exports.getEnvironment = getEnvironment;
const isProd = () => (0, exports.getEnvironment)() === Environment_1.Environment.PROD;
exports.isProd = isProd;
const isTest = () => (0, exports.getEnvironment)() === Environment_1.Environment.TEST;
exports.isTest = isTest;
const isLocal = () => (0, exports.getEnvironment)() === Environment_1.Environment.LOCAL;
exports.isLocal = isLocal;
const isNonProd = () => (0, exports.getEnvironment)() === Environment_1.Environment.TEST;
exports.isNonProd = isNonProd;
const getEnvVariable = (key) => {
    const variablesMap = envVariables_1.default[key];
    switch ((0, exports.getEnvironment)()) {
        case Environment_1.Environment.LOCAL:
            return variablesMap.local;
        case Environment_1.Environment.TEST:
            return variablesMap.test;
        default:
            return variablesMap.prod;
    }
};
exports.getEnvVariable = getEnvVariable;
